import React, {useCallback} from "react";
import http from "service/api";
import {Api} from "settings/index";
import {isSuccessResponse} from "shared/validators";
import {pick} from "lodash";
import {ModalHelper} from "shared/modal";
import {ErrorMessageContent} from "components/style-guide/modal/components/ErrorMessage/ErrorMessageContent";
import {toastHelper} from "shared/toast";

export const useSendContact = () => {
    const sendContactInfo = useCallback(async (values) => {
        try {
            const value = pick(values, ['rut', 'email', 'phone', "comments"])
            const response = await http.post(Api.sendContactInfo, {
                ...value,
                "phone": "+" + value.phone,
                "name_lastname": values.name,
            });

            if (isSuccessResponse(response)) {
                toastHelper.success("Datos enviados correctamente.");
                return;
            }
        } catch (e) {

        }

        ModalHelper.open('',
            <ErrorMessageContent
                message="Inserte nuevamente los datos. Si el error persiste contáctenos."/>, null, {className: 'empty-modal-title'}
        );
    }, []);

    return {sendContactInfo};
}
